import React from 'react'

import useAllCash from '../hooks/useAllCash'

import TRow from './TRow'

const TBody = () => {

    const {data} = useAllCash()
  return (
    <>
      {data.map((doc) => (
        <TRow key={doc.id || doc._id} doc={doc} />
      ))}
    </>
  )
}

export default TBody